import * as React from "react";
import Typography from "@mui/material/Typography";

interface props {
  title: string;
}
export const PedidosImportacaoTopo = (param: props) => {
  return (
    <React.Fragment>
      <Typography
        variant="h5"
        fontFamily={"Co Headline Regular"}
        gutterBottom
        align="left"
        marginLeft="15px"
      >
        {param.title}
      </Typography>
    </React.Fragment>
  );
};
export default PedidosImportacaoTopo;
